import React from "react";
import { SearchContent } from "src/content";

const Search = () => {
  return (
    <div>
      <SearchContent />
    </div>
  );
};

export default Search;
